import React, { useContext, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Logout from '../../components/modal/logout';
import { MyContext } from '../../context';
import { makeDeleteCall, makeGetCall, makePatchCall } from '../../effects/requests';
import { cookieService } from '../../services';
import { CREW_GROUP_STATUS, EXPLORE_TYPE, PERMISSION_TYPE, ROLE_TYPE, USER_TYPE } from '../../types';
import { defaultJobFilter, defaultSupplierFilter, viewProfileTab } from '../../utils/constants';
import { endPoints } from '../../utils/endpoints';
import { createFullName, emptyFunction, getCompanyName } from '../../utils';
interface SideBarProps {
    children?: React.ReactNode
}

const SideBarLayout = (props: SideBarProps) => {

    const [showMenu, setShowMenu] = useState(false);
    const [isLogOut, setIsLogOut] = useState(false);
    const { userData, updateUserData, companies, updateCompanyData } = useContext(MyContext)
    const [showProdDropdown, setShowProdDropdown] = useState(false);

    const location = useLocation();
    const navigate = useNavigate();

    const pathName = location?.pathname || "";

    const onLogOut = () => {
        makeDeleteCall(endPoints.LOGOUT, { device_type: 'WEB' }).then(clearAll).catch(clearAll)
    }

    const clearAll = () => {
        updateUserData(null)
        cookieService.removeAllCookies();
        navigate('/sign-in');
    }

    const haveFullPermission = userData?.user_type === USER_TYPE.TYPE_CREW ? true : false;

    const selectProduction = (item: any) => {
        const urls = `${endPoints.USER_PRODUCTION}${item?.id}/`
        makePatchCall(urls, { is_active: true }).then((res) => {
            makeGetCall(endPoints.PROFILE).then((res) => {
                updateUserData(res);
                getCompanyNames();
            }).catch(emptyFunction)
        }).catch(emptyFunction)
    }

    const getCompanyNames = () => {
        makeGetCall(endPoints.USER_PRODUCTION, null, false, true).then((res) => {
            if (res?.results?.length > 0) {
                const data = res?.results?.map((item: any) => {
                    if (item?.company_department && typeof item?.company_department == 'string') {
                        item.company_department = JSON.parse(item?.company_department)
                    }
                    item.label = item?.production_company?.company_name || ''
                    item.value = item?.production_company?.id || ''
                    return item
                })
                updateCompanyData(data);
            }
        }).catch(emptyFunction)
    }

    const crewName = (userData?.user_type === ROLE_TYPE.TYPE_CREW && userData?.permission_type === PERMISSION_TYPE.TYPE_CREW_MEMBER) ? createFullName(userData?.first_name, userData?.last_name) : ''
    const productionCompanyName = getCompanyName(userData);

    const filteredData = companies?.filter((item: any) => item?.production_company?.company_name);

    return (
        <div>
            <div className="view-profile-layout">
                <div style={{ maxWidth: '190px', overflow: 'scroll' }} className={`left-menu-design text-center ${showMenu ? "show-menu" : ""}`}>
                    <div className="top-menu">
                        <div className='mobile-menu' onClick={() => setShowMenu(!showMenu)}>
                            <span></span>
                        </div>
                        <img style={{ cursor: 'pointer' }} onClick={() => navigate('/schedule/')} src={"/assets/images/yello-logo.png"} alt="" />
                        <div className="bottom-menu-colleps">
                            {haveFullPermission &&
                                <div><button style={{ cursor: (filteredData.length > 1) ? 'pointer' : 'default' }} className='text-center justify-content-center' onClick={() => setShowProdDropdown(!showProdDropdown)}>
                                    <span>{crewName ? crewName : ''} {productionCompanyName}</span>
                                    {(filteredData.length > 1) && <img src={"/assets/images/down-white-arrow.svg"} alt="" style={{ width: '10px', height: '10px', marginLeft: '5px' }} />}
                                </button>
                                    {showProdDropdown && (filteredData.length > 1) &&
                                        <div className='multi-prod'>
                                            {filteredData?.map((item: any, index: number) => {
                                                return (
                                                    item.is_active
                                                        ?
                                                        <div className='d-flex justify-content-between' key={item?.id ?? index}>
                                                            <p className='selected-prod other-event-title'>{item?.production_company?.company_name} </p>
                                                            <img style={{ width: '20px', height: '20px', paddingLeft: '5px' }} src={"/assets/images/check-purple.svg"} alt="" />
                                                        </div>
                                                        :
                                                        <p className='other-event-title'
                                                            key={item?.id ?? index}
                                                            onClick={() => {
                                                                selectProduction(item);
                                                                setShowProdDropdown(!showProdDropdown);
                                                            }}
                                                        >
                                                            {item?.production_company?.company_name}
                                                        </p>
                                                )
                                            })}
                                        </div>
                                    }
                                </div>
                            }
                            <ul className="top-menu-link mb-0">
                                <li className="nav-section-label">Menu</li>
                                <li className={pathName.includes('/suppliers') ? 'active' : ''}>
                                    <Link to='/suppliers' state={defaultSupplierFilter}>
                                        <img src={"/assets/images/menu-icon/Suppliers.svg"} alt="" />
                                        <img src={"/assets/images/menu-icon/Suppliers-active.svg"} alt="" />
                                        {viewProfileTab.tab2}</Link>
                                </li>
                                <li className={pathName.includes('/explore') ? 'active' : ''}>
                                    <Link to={`/explore/?type=${EXPLORE_TYPE.EX_CREW}&search=&department=&location=&limit=12&role=&joining_date_current_company=&start_date=&end_date=&permission_type=&lat=&lng=`}>
                                        <img src={"/assets/images/menu-icon/Crew.svg"} alt="" />
                                        <img src={"/assets/images/menu-icon/Crew-active.svg"} alt="" />
                                        {viewProfileTab.tab3}</Link>
                                </li>
                                <li className={pathName.includes('/messages') ? 'active' : ''}>
                                    <Link to={`/messages/?search=&user_type=${USER_TYPE.TYPE_SUPPLIER}&room=`}>
                                        <img src={"/assets/images/menu-icon/Messages.svg"} alt="" />
                                        <img src={"/assets/images/menu-icon/Messages-active.svg"} alt="" />
                                        {viewProfileTab.tab5}</Link>
                                </li>
                                <li className={`${userData?.unread_notification_count && !pathName.includes('/notifications') ? 'notify-notification ' : ' '}${pathName.includes('/notifications') ? 'active' : ''}`}>
                                    <Link to="/notifications">
                                        <img src={"/assets/images/menu-icon/Notifications.svg"} alt="" />
                                        <img src={"/assets/images/menu-icon/Notifications-active.svg"} alt="" />
                                        {viewProfileTab.tab6}</Link>
                                </li>
                                <li className={(pathName?.includes('/location/myvault') || pathName?.includes('/location-detail/myvault') || pathName?.includes('/location-gallery/myvault') || pathName?.includes('/location-communication/myvault') || pathName?.includes('/location-sharing/myvault') || pathName?.includes('/location-folders/myvault')) ? 'active' : ''}>
                                    <Link to={`/location/myvault`}>
                                        <img src={"/assets/images/menu-icon/location-vault.svg"} alt="" />
                                        <img src={"/assets/images/menu-icon/location-vault-active.svg"} alt="" />
                                        My Vault
                                    </Link>
                                </li>
                            </ul>
                            {haveFullPermission &&
                                <ul className="top-menu-link group-divider mb-0">
                                    <li className="nav-section-label">Production Suite</li>
                                    <li className={pathName.includes('/schedule') ? 'active' : ''}>
                                        <Link to={`/schedule/`}>
                                            <img src={"/assets/images/menu-icon/Schedule.svg"} alt="" />
                                            <img src={"/assets/images/menu-icon/Schedule-active.svg"} alt="" />
                                            {viewProfileTab.tab1}</Link>
                                    </li>
                                    <li className={(pathName?.includes('/location/vault') || pathName?.includes('/location-detail/vault') || pathName?.includes('/location-gallery/vault') || pathName?.includes('/location-communication/vault') || pathName?.includes('/location-sharing/vault') || pathName?.includes('/location-folders/vault')) ? 'active' : ''}>
                                        <Link to={`/location/vault`}>
                                            <img src={"/assets/images/menu-icon/location-vault.svg"} alt="" />
                                            <img src={"/assets/images/menu-icon/location-vault-active.svg"} alt="" />
                                            Location Vault
                                        </Link>
                                    </li>
                                    <li className={(pathName?.includes('/users-audit')) ? 'active' : ''}>
                                        <Link to={`/users-audit`}>
                                            <img src={"/assets/images/menu-icon/Crew.svg"} alt="" />
                                            <img src={"/assets/images/menu-icon/Crew-active.svg"} alt="" />
                                            Users & Audit
                                        </Link>
                                    </li>
                                    <li className={pathName.includes('/crew-groups') ? 'active' : ''}>
                                        <Link to={`/crew-groups/?status=${CREW_GROUP_STATUS.MY_GROUP}&search=`}>
                                            <img src={"/assets/images/menu-icon/crew-group.svg"} alt="" />
                                            <img src={"/assets/images/menu-icon/crew-group-active.svg"} alt="" />
                                            Crew Groups
                                        </Link>
                                    </li>
                                    <li className={pathName.includes('/back-pages') ? 'active' : ''}>
                                        <Link to={`/back-pages/?search=&department=&role=&event_type=`}>
                                            <img src={"/assets/images/menu-icon/back-page.svg"} alt="" />
                                            <img src={"/assets/images/menu-icon/back-page-active.svg"} alt="" />
                                            Backpages
                                        </Link>
                                    </li>
                                    <li className={pathName.includes('/jobs') ? 'active' : ''}>
                                        <Link
                                            to='/jobs'
                                            state={defaultJobFilter(getCompanyName(userData))}
                                        >
                                            <img src={"/assets/images/menu-icon/Jobs.svg"} alt="" />
                                            <img src={"/assets/images/menu-icon/Jobs-active.svg"} alt="" />
                                            {viewProfileTab.tab4}</Link>
                                    </li>
                                </ul>
                            }
                        </div>
                    </div>
                    <div className="bottom-menu">
                        <ul className="top-menu-link mb-0">
                            <li className={(pathName.includes('/view-profile')) ? 'active' : ''}>
                                <Link to="/view-profile">
                                    <img src={"/assets/images/menu-icon/Profile.svg"} alt="" />
                                    <img src={"/assets/images/menu-icon/Profile-active.svg"} alt="" />
                                    {viewProfileTab.tab8}</Link>
                            </li>
                            <li>
                                <Link onClick={() => setIsLogOut(true)} to="#">
                                    <img src={"/assets/images/menu-icon/Log-Out.svg"} alt="" />
                                    <img src={"/assets/images/menu-icon/Log-Out-active.svg"} alt="" />
                                    {viewProfileTab.tab9}</Link>
                            </li>
                        </ul>
                    </div>
                </div>
                {props?.children}
                <Logout
                    show={isLogOut}
                    closePopup={() => setIsLogOut(false)}
                    onLogOut={() => {
                        setIsLogOut(false)
                        onLogOut?.()
                    }}
                />
            </div>
        </div>
    )
}

export default SideBarLayout